<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper">
      <package-category-editor
        v-model="form"
        :iconUrl="iconUrl"
        :disabled="$isCallCenter"
      ></package-category-editor>
      <div class="text-right" v-if="!$isCallCenter">
        <!-- <sc-button
          class="btn-remove"
          variant="danger"
          @click="handleClickRemove"
        >ลบ</sc-button> -->
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import PackageCategoryEditor from "../components/PackageCategoryEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";
import { isEmpty } from "ramda";
import { toCamelCaseObject } from '@/lib/util';

export default {
  components: {
    PageWrapper,
    ScButton,
    PackageCategoryEditor
  },
  data() {
    const title = "รายละเอียด Category";
    const form = {
      name: "",
      packages: [],
      iconFile: null
    };

    const packages = [];
    const iconUrl = null;

    return {
      title,
      form,
      iconUrl,
      packages
    };
  },
  watch: {
    form(form, oldForm) {
      if (this.form.iconFile === oldForm.iconFile) {
        return;
      }

      this.iconUrl = URL.createObjectURL(this.form.iconFile);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();
    },
    setupData() {
      this.setupCategory();
    },
    async setupCategory() {
      const {
        name,
        icon_url,
        packages
      } = await this.fetchData();

      this.form = {
        ...this.form,
        name,
        packages: packages ? toCamelCaseObject(packages) : []
      }

      this.iconUrl = icon_url;
    },
    async fetchData() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.ruejaiClub.categories.get(
        id
      );

      return response.data.result;
    },
    async handleClickSave() {
      if (!confirm("ยืนยันการบันทึก")) {
        return;
      }

      try {
        await this.update();
        this.$router.push({ name: "RuejaiClubCategoryListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async handleClickRemove() {
      if (!confirm("ยืนยันการลบ")) {
        return;
      }

      try {
        await this.remove();
        alert("ลบเรียบร้อย");
        this.$router.push({ name: "RuejaiClubCategoryListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async update() {
      const { id } = this.$route.params;
      const params = await this.getUpdateParams();

      const response = await baanRueJaiClient.admin.ruejaiClub.categories.put(
        id,
        params
      );

      return response.data.result;
    },
    async getUpdateParams() {
      const { name, iconFile, packages } = this.form;

      const package_ids = packages.map(item => item.id);
      const icon_url = iconFile
        ? await uploadPublicImage(iconFile, name, "article")
        : this.iconUrl;

      const params = { name, package_ids, icon_url };

      return params;
    },
    async remove() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.ruejaiClub.categories.delete(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}

.btn-remove {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/category/pages/RuejaiClubCategoryDetailPage.vue